import React from 'react'
import { Segment, Container, Image, Table, Grid} from 'semantic-ui-react'
import Icon from "react-icons-kit"

import './CardOverview.css'

const CardOverview = ({titre, prestations, icon}) => (
    <div className="cardOverview">
      <div className="wrapper">
        <Container className="title">
          <Icon size={20} className="titleIcon" icon={icon} />
          {titre}
        </Container>
          <Container className="body">
            <Grid columns="equal">
                {
                  (prestations || []).map(presta => (
                    <Grid.Row className="cardLine">
                      <Grid.Column>{presta.nameCustomer}</Grid.Column>
                      <Grid.Column>{presta.namePrestations}</Grid.Column>
                      <Grid.Column className="priceCol">{presta.price}</Grid.Column>
                    </Grid.Row>
                  ))
                }
            </Grid>
          </Container>
      </div>
    </div>
)

export default CardOverview



// WEBPACK FOOTER //
// ./src/components/Pro/Accueil/CardOverview.jsx